function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <p>© {new Date().getFullYear()} Vision Forte LLC. All rights reserved.</p>
        <p className="muted">Software engineering, delivered with clarity and care.</p>
      </div>
    </footer>
  );
}

export default Footer;
